var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vx-card',{staticClass:"p-6",attrs:{"title":"Счетчик"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }